import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import PropTypes from "prop-types";
import { STATUS_COLORS } from "constant/colors";

ChartJS.register(ArcElement, Tooltip, Legend);

function RepartitionPuceChart({ lotPuce, openAction, handleClose }) {
  // console.log("ss ", lotPuce?.puceCount);
  const filtered = lotPuce?.puceCount?.filter((item) => item?.count > 0);
  const dataWithBg = filtered?.map((item) => ({
    ...item,
    backgroundColor: STATUS_COLORS[item?.status],
  }));
  const data = {
    labels: filtered.map((item) => item.status),
    datasets: [
      {
        label: "Répartition des puces",
        data: filtered.map((item) => item.count),
        backgroundColor: dataWithBg.map((item) => item.backgroundColor),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label(context) {
            const item = filtered[context.dataIndex];
            return `${item.status}: ${item.count} (${item.percentage.toFixed(2)}%)`;
          },
        },
      },
    },
  };
  return (
    <Dialog
      open={openAction}
      onClose={() => handleClose(false)}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        Repartition des puces du lot {lotPuce?.reference}
      </DialogTitle>
      <DialogContent>
        <Pie data={data} options={options} />
      </DialogContent>
    </Dialog>
  );
}

RepartitionPuceChart.propTypes = {
  lotPuce: PropTypes.object,
  openAction: PropTypes?.bool,
  handleClose: PropTypes?.func,
};

RepartitionPuceChart.defaultProps = {
  lotPuce: null,
  openAction: false,
  handleClose: () => {},
};
export default RepartitionPuceChart;
